"use strict";

import Widgets from 'js-widget-hooks';


Widgets.register('tdot-events', function(el){

    import(/* webpackChunkName: "tdot" */ './specialwidgets/TdotEvents.jsx').then(function (module) {
        module.default(el);
    });

});